// Converte o numero guardado do contato para o formato de discagem do PBX:
// DDD + numero, COM o 9 em celular, SEM o 55. Fixo (8 digitos, comeca 2-5)
// nao ganha o 9.
//
//   554884015531  -> 48984015531   (celular sem o 9, adiciona)
//   5548984015531 -> 48984015531   (celular com o 9, mantem)
//   554832201030  -> 4832201030    (fixo, sem 9)
export function paraDiscagem(bruto) {
  let n = String(bruto || "").replace(/\D/g, "");
  if (!n) return "";

  // Codigo do pais 55: so quando o numero tem DDI (12-13 digitos).
  if (n.length >= 12 && n.length <= 13 && n.startsWith("55")) {
    n = n.slice(2);
  }

  if (n.length < 10) return n; // curto demais (ja e ramal ou incompleto)

  const ddd = n.slice(0, 2);
  let local = n.slice(2);

  if (local.length === 9 && local[0] === "9") {
    // celular com 9 -> mantem
  } else if (local.length === 8) {
    if ("6789".includes(local[0])) {
      local = "9" + local; // celular sem 9 -> adiciona
    }
    // 2,3,4,5 -> fixo -> mantem sem 9
  }

  return ddd + local;
}
